import { styled } from 'styled-components';

const Textarea = styled.textarea<{ rows?: number }>`
  border-radius: 4px;
  width: 100%;
  border: solid 1px ${({ theme }) => theme.colors.grey30_1};
  height: ${({ rows }) => (rows && rows > 1 ? `${rows * 38}px` : '38px')};
  padding: 8px 12px;
  font-size: 14px;
  font-family: CircularXXWeb, Roboto, sans-serif;
  color: ${({ theme }) => theme.colors.black_1};
  resize: none;
  transition: all 100ms;
  appearance: none;
  background-color: ${({ theme }) => theme.colors.grey00_7};

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey70_1};
  }

  &[disabled],
  &[readonly] {
    background-color: ${({ theme }) => theme.colors.grey05_3};
    border-color: ${({ theme }) => theme.colors.grey30_2};
    cursor: not-allowed;
  }
  &[disabled] {
    color: ${({ theme }) => theme.colors.grey100_2};
    &::placeholder {
      color: ${({ theme }) => theme.colors.grey100_2};
    }
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.main};
    outline: none;
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.main};
  }
  &:not([disabled]):not([readonly]):not(:focus):hover {
    border-color: ${({ theme }) => theme.colors.grey70_1};
  }
`;

export { Textarea };
